import { Box, Button } from "@mui/material";
import { observer } from "mobx-react";
import { FC } from "react";

import { useChatStore } from "../../../../hooks/useChatStore";
import { PreDefaultQuestionType } from "../../../../types/claims";
import { useClaimsStore } from "../../../../hooks/useClaimsStore";

interface ChatInputPredefaultQuestionsProps {
  preDefaultQuestions: PreDefaultQuestionType[];
  predefaultSubmitState: boolean;
  onQuestionClick: (
    e: React.FormEvent<HTMLFormElement>,
    question: PreDefaultQuestionType,
  ) => void;
}

const ChatInputPredefaultQuestions: FC<ChatInputPredefaultQuestionsProps> =
  observer(({ preDefaultQuestions, onQuestionClick, predefaultSubmitState }) => {
    const chatStore = useChatStore();
    const claimsStore = useClaimsStore();

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 0.5,
          flexWrap: "wrap",
        }}
      >
        {preDefaultQuestions.map((question) => (
          <Button
            key={question.question}
            variant="outlined"
            size="small"
            disabled={
              claimsStore.claimActivePredefaultQuestion
                ? predefaultSubmitState
                : chatStore.isAborting ||
                  chatStore.isQuestioning ||
                  chatStore.isFileUploadInProgress
            }
            sx={{ fontSize: "12px", borderRadius: "16px" }}
            onClick={(e) =>
              onQuestionClick(
                e as unknown as React.FormEvent<HTMLFormElement>,
                question,
              )
            }
          >
            {question.question}
          </Button>
        ))}
      </Box>
    );
  });

export default ChatInputPredefaultQuestions;
